import type { SuggestionsResponse } from "@/types/v2/search"

// Cold-start suggestions fetch (CON-186).
//
// `GET /v2/searches/suggestions` returns the business's most
// recently active records (deals / contacts / companies) in the
// navigate-only row shape. The palette calls this ONCE on open,
// only when the user has no localStorage search history yet, to
// seed the RECENT section with the user's own data instead of
// hard-coded example chips.

export const SUGGESTIONS_ENDPOINT = "/v2/searches/suggestions"

export async function fetchSuggestions(
  { signal }: { signal?: AbortSignal } = {},
): Promise<SuggestionsResponse> {
  const response = await fetch(SUGGESTIONS_ENDPOINT, {
    method: "GET",
    headers: { Accept: "application/json" },
    credentials: "same-origin",
    signal,
  })

  if (!response.ok) {
    throw new Error(`Suggestions request failed: ${response.status}`)
  }

  return (await response.json()) as SuggestionsResponse
}
